import SmallDetails from "components/SmallDetails/SmallDetails";
import moment from "moment";
import React from "react";
import { formatWrittenDayMonthYear } from "utilities";
import { getInvoiceDueDate, getOverdueDaysCount, isInvoiceOverdue } from "utilities/invoiceUtils";

interface Props {
  //invoice: server.dto.InvoiceV1 | server.dto.InvoiceV2;
  invoiceDate: moment.Moment;
  lifeCycle: server.dto.DocumentLifeCycles
  dueInDays: number;
  hasProducts: boolean;
}

export const InvoiceDueDate = (props: Props) => {
  const isOverDue = isInvoiceOverdue(props.invoiceDate.toDate(), props.dueInDays, props.lifeCycle);
  const isCompletedOrDiscarded = props.lifeCycle === "completed" || props.lifeCycle === "discarded";
  const dueDate = getInvoiceDueDate(props.invoiceDate, props.dueInDays);

  let sublabel: string = null;
  let error = false;

  if (isCompletedOrDiscarded && props.hasProducts) {
    const days = props.dueInDays;
    const termLabel = days === 1 ? RESX.DateTime.YDay : `${days} ${RESX.DateTime.days}`;
    sublabel = `${RESX.Invoice.PaymentTerm}: ${termLabel}`;
    error = false;
  } else if (isOverDue) {
    const overdueDays = getOverdueDaysCount(props.invoiceDate.toDate(), props.dueInDays);
    if (overdueDays === 0) {
      sublabel = RESX.DateTime.Today;
    }
    else if (overdueDays === 1) {
      sublabel = RESX.DateTime.YDayOverDue;
    } else {
      sublabel = RESX.DateTime.XDaysOverDue.replace("{0}", overdueDays.toString());
    }
    error = true;
  } else {
    sublabel = dueDate.isSame(moment.utc(), "day")
      ? RESX.DateTime.Today
      : dueDate.clone().startOf("day").from(moment.utc().startOf("day"));
    error = false;
  }

  return <SmallDetails
    label={formatWrittenDayMonthYear(dueDate)}
    subLabel={sublabel}
    error={error}
  />
}